module.exports = __webpack_public_path__ + "static/scale-model-of-dragon's-gate-in-san-francisco-california-5318030585781a2660dadab149134ba1.png";